export const mensajesInbox = {
  title: "Wiadomości",

  noAccess: {
    description:
      "Aby uzyskać dostęp do skrzynki wiadomości, trzeba mieć podłączony własny numer WhatsApp Business w ustawieniach konta.",
    connectButton: "Połącz WhatsApp",
  },

  search: {
    placeholder: "Szukaj po telefonie lub gościu...",
  },

  filters: {
    allProperties: "Wszystkie obiekty",
    searchProperty: "Szukaj obiektu...",
    filterTitle: "Filtruj wiadomości",
    clearAll: "Wyczyść filtry",
    removeOne: "Usuń „{filtro}”",
    someActive: "Filtry: {count}",
  },

  tabs: {
    all: "Wszystkie",
    unread: "Nieprzeczytane",
    pinned: "Przypięte",
    archived: "Zarchiwizowane",
    noReservation: "Bez rezerwacji",
    otaBooking: "Booking.com",
    otaAirbnb: "Airbnb",
    otaExpedia: "Expedia",
    otaOther: "Inna OTA",
    unpaid: "Nieopłacone",
    paid: "Opłacone",
    arrivingSoon: "Wkrótce przyjazd",
  },

  filterGroups: {
    chat: "Rozmowa",
    origin: "Źródło",
    reservation: "Rezerwacja",
  },

  list: {
    empty: "Brak rozmów",
    noMessages: "Brak wiadomości",
  },

  channels: {
    web: "Strona",
    webConcierge: "Konsjerż na stronie · Portal pobytu",
    otaMessage: "Wiadomość z {provider}",
  },

  chat: {
    placeholderSelect: "Wybierz rozmowę, aby zacząć",
    loading: "Wczytywanie rozmowy...",
    dropToAttach: "Upuść tutaj, aby załączyć pliki",
    emptyThread: "W tym wątku nie ma jeszcze wiadomości",
    notSent: "Nie wysłano",
    sending: "Wysyłanie...",
  },

  sender: {
    guest: "Gość",
    you: "Ty",
    aiAgent: "Agent AI",
  },

  media: {
    document: "Dokument",
    sharedLocation: "Udostępniona lokalizacja",
    attachment: "Załącznik",
  },

  preview: {
    attachmentSent: "Wysłano załącznik",
    messageSent: "Wysłano wiadomość",
    attachmentReceived: "Otrzymano załącznik",
    newMessage: "Nowa wiadomość",
  },

  mode: {
    aiAgent: "Agent AI",
    manual: "Ręczny",
  },

  automation: {
    disabledNotice:
      "Agent AI nie jest włączony dla tego obiektu: nie odpowie, wiadomości piszesz samodzielnie.",
    aiActiveBanner:
      "Agent AI odpowiada temu gościowi automatycznie.",
  },

  faq: {
    title: "Najczęściej zadawane pytania",
  },

  composer: {
    placeholder: "Napisz wiadomość lub wpisz /, aby wstawić odpowiedź...",
    hint: "Enter wysyła · Shift+Enter nowa linia",
  },

  actions: {
    newConversation: "Nowa rozmowa",
    options: "Opcje",
    attachFile: "Załącz plik",
  },

  alt: {
    flag: "Flaga",
    sentImage: "Wysłane zdjęcie",
  },

  common: {
    file: "plik",
    notAvailable: "Niedostępne",
  },

  nights: "{count} noc | {count} noce | {count} nocy",

  arrival: {
    pending: "Data do ustalenia",
    today: "Przyjazd dzisiaj",
    tomorrow: "Przyjazd jutro",
    yesterday: "Przyjazd wczoraj",
    inDays: "Za {count} dni",
    daysAgo: "Przyjazd {count} dni temu",
  },

  reservationStatus: {
    booked: "Potwierdzona",
    cancelled: "Anulowana",
    pending: "Oczekująca",
    checked_in: "Zameldowany",
    checked_out: "Wymeldowany",
  },

  reservationPanel: {
    title: "Powiązana rezerwacja",
    stayEnded: "Gość już nie przebywa w obiekcie",
    checkIn: "Check-in",
    checkOut: "Check-out",
    room: "Pokój",
    reservation: "Rezerwacja",
    phone: "Telefon",
    viewReservation: "Zobacz rezerwację",
    noReservationTitle: "Brak powiązanej rezerwacji",
    noReservationOta:
      "Ten wątek pochodzi z {channel} przez Channex i nie jest jeszcze powiązany z lokalną rezerwacją.",
    noReservationWhatsapp:
      "Ten kontakt napisał na podłączony WhatsApp, ale nie jest jeszcze powiązany z rezerwacją.",
    assignReservation: "Przypisz rezerwację",
    createReservation: "Utwórz rezerwację",
    assignExisting: "Przypisz istniejącą rezerwację",
    searchPlaceholder: "Szukaj po nazwisku lub kodzie...",
    noReservationsFound: "Nie znaleziono rezerwacji",
    placeholderContext: "Wybierz rozmowę, aby zobaczyć kontekst",
    propertyUnavailable: "Obiekt niedostępny",
  },

  contextMenu: {
    pin: "Przypnij rozmowę",
    unpin: "Odepnij rozmowę",
    archive: "Archiwizuj rozmowę",
    unarchive: "Przywróć rozmowę z archiwum",
  },

  waStatus: {
    read: "Przeczytana",
    delivered: "Dostarczona",
    queued: "W kolejce",
    failed: "Niepowodzenie",
    sent: "Wysłana",
  },

  waFailTitle: {
    noWhatsapp: "Brak WhatsApp",
    invalidNumber: "Nieprawidłowy numer",
    notSent: "Nie wysłano",
  },

  waErrors: {
    generic: "Tej wiadomości nie udało się wysłać przez WhatsApp.",
  },

  waErrorShort: {
    e131042: "problem z płatnością na koncie WhatsApp",
    e131026: "numer nie może odbierać wiadomości WhatsApp",
    e131053: "WhatsApp nie mógł pobrać pliku",
    e132000: "brak danych w szablonie",
    e131009: "wiadomość nie spełnia wymagań WhatsApp",
  },

  toasts: {
    aiActiveSwitchManual:
      "Agent AI jest aktywny. Przełącz na tryb ręczny, aby odpowiedzieć.",
    pinned: "Rozmowa przypięta",
    unpinned: "Rozmowa odpięta",
    archived: "Rozmowa zarchiwizowana",
    unarchived: "Rozmowa przywrócona z archiwum",
    reservationAssigned: "Rezerwacja przypisana: {name}",
    reservationUnassigned: "Rezerwacja odłączona",
    selectPropertyToCreate:
      "Wybierz obiekt, aby utworzyć rezerwację z tego czatu.",
    userNotResolved: "Nie udało się ustalić użytkownika panelu.",
    aiNotEnabledConfig:
      "Ten obiekt nie ma włączonego agenta AI. Włącz go w ustawieniach oferty.",
    aiEnabledForChat: "Agent AI włączony dla tej rozmowy",
    manualEnabledForChat: "Tryb ręczny włączony dla tej rozmowy",
    templateSent: "Szablon wysłany pomyślnie.",
  },

  errors: {
    inboxNotActive:
      "Skrzynka wiadomości nie jest aktywna dla tego konta albo firmowy WhatsApp nie został jeszcze podłączony.",
    openConversation: "Nie udało się otworzyć rozmowy",
    sendMessage: "Nie udało się wysłać wiadomości. Sprawdź połączenie z WhatsApp.",
    pin: "Błąd podczas przypinania rozmowy",
    archive: "Błąd podczas archiwizowania",
    loadReservations: "Błąd podczas wczytywania rezerwacji",
    assignReservation: "Błąd podczas przypisywania rezerwacji",
    unassignReservation: "Błąd podczas odłączania rezerwacji",
    updateMode: "Nie udało się zaktualizować trybu tej rozmowy",
    reactivationTemplate: "Nie udało się wysłać szablonu reaktywacji.",
  },
};
